import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { IUserPrinterViewModel } from '@core/models';
import { AppMessageService, PrintStationCommandService, ValidatorErrorHandlerService } from '@core/services';
import { PrinterStateService } from '@core/services/printer-state.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ConfirmMessagePosition, State } from '@shared/enums';
import { NavigationService } from '@shared/services';
import _ from 'lodash';
import { exhaustMap, finalize, Observable, Subject, tap } from 'rxjs';

@UntilDestroy()
@Component({
	selector: 'printers-sidebar',
	templateUrl: './printers-sidebar.component.html',
	styleUrl: './printers-sidebar.component.scss',
	standalone: false,
})
export class PrintersSidebarComponent implements OnInit, OnDestroy {
	@Input() isVisible: boolean = false;
	@Output() isVisibleChange = new EventEmitter();

	public isCalibrateConfirmVisible: boolean = false;
	public confirmMessagePositionEnum = ConfirmMessagePosition;
	public isSpinnerShown: boolean = false;

	public printerStateEnum = State;
	public printers$: Observable<IUserPrinterViewModel[]>;
	private _onCalibrate$: Subject<IUserPrinterViewModel> = new Subject();
	public selectedPrinter?: IUserPrinterViewModel;

	constructor(
		public navigationService: NavigationService,
		private _messageService: AppMessageService,
		private _commandService: PrintStationCommandService,
		private validatorErrorHandler: ValidatorErrorHandlerService,
		private printerStateService: PrinterStateService,
	) {
		this.printers$ = this.printerStateService.getPrinters$();

		this._onCalibrate$
			.pipe(
				tap(_ => (this.isSpinnerShown = true)),
				exhaustMap(printer => {
					return this._commandService.calibrate(printer.clientId, printer.serialNumber).pipe(
						finalize(() => (this.isSpinnerShown = false)),
						this.validatorErrorHandler.catchError(),
					);
				}),
			)
			.subscribe(() => {
				this.onHide();

				this._messageService.warn(
					'Do not turn printer power off! Do not start printing!',
					'Printer is calibrating. It may take up to 5 minutes.',
				);
			});
	}

	public ngOnInit(): void {
		this.printerStateService.init();
	}

	public ngOnDestroy(): void {
		this.printerStateService.destroy();
	}

	public onHide() {
		this.isVisibleChange.emit((this.isVisible = false));
	}

	public calibrate() {
		if (this.selectedPrinter) {
			this._onCalibrate$.next(this.selectedPrinter);
			this.selectedPrinter = undefined;
		}
	}

	public showCalibrateConfirm(printer: IUserPrinterViewModel) {
		this.selectedPrinter = printer;
		this.isCalibrateConfirmVisible = true;
	}

	public pausePrintJobs() {
		return;
	}
}
